import { NextPage } from 'next'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { IDeal } from '@types'
import { AppLayout, FAQSection, PartialContainer, Button } from '@components'
import { InflationHedgeHero } from '@partials/InflationHedge/inflation-hedge-hero'
import { InflationHedgeContent } from '@partials/InflationHedge/inflation-hedge-content'
import { InflationHedgePotentialReturn } from '@partials/InflationHedge/inflationhedge-potential-return'
import { InflationHedgeDiversify } from '@partials/InflationHedge/inflation-hedge-diversify'
import TreasuryBillmage from '@partials/InflationHedge/inflation-hedge-content/treasury-bill.png'
import PrivateMarketImage from '@partials/InflationHedge/inflation-hedge-content/private-market.png'
import BullImage from '@partials/InflationHedge/inflation-hedge-content/bull.png'
import { NextSeo } from 'next-seo'

const InflationHedge: NextPage<{}> = () => {
  const [dealData, setDealData] = useState<IDeal | null>(null)
  const [investmentAmount, setInvestmentAmount] = useState(10000)

  useEffect(() => {
    axios
      .get(
        process.env.NEXT_PUBLIC_API_URL + `/companies/mainDeal/inflationhedge`,
      )
      .then(response => {
        response?.data && setDealData(response?.data?.deals[0])
        setInvestmentAmount(response?.data?.deals[0]?.minimumInvestment)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  return (
    <AppLayout>
      <NextSeo
        title="Inflation Hedge"
        description="Inflation, recession, rate hikes, bank runs... these uncertainties have prompted many investors to turn to cash as a “safe” investment option.  Is this really the smartest move for you?"
        canonical="https://www.marketxventures.com/inflationhedge"
      />
      <InflationHedgeHero closingAt={dealData?.closingAt} id={dealData?.id} />
      <InflationHedgeContent
        heading="Market conditions are uncertain. What should you do?"
        subHeading="Inflation, recession, rate hikes, bank runs... these uncertainties have prompted many investors to turn to cash as a “safe” investment option.  Is this really the smartest move for you?"
        description="<p>The yields of some Treasuries and savings accounts
          are not outpacing inflation.  To seek equity-like returns,
          investors need to be more <span>creative in diversifying into
          alternative investments </span> like the super-rich do. </p>
          
          <p>This hybrid investment opportunity combines<span> private
          investment securities</span> with a <span>structured interest rate
          hedge,</span> providing an opportunity for positive returns
          while protecting the principal investment.</p>"
        imageUrl={TreasuryBillmage}
      />
      <InflationHedgePotentialReturn
        id={dealData?.id}
        minimumInvestment={dealData?.minimumInvestment}
        allocation={dealData?.allocation}
        closingAt={dealData?.closingAt}
        setInvestmentAmount={setInvestmentAmount}
        investmentAmount={investmentAmount}
      />
      <InflationHedgeDiversify />

      <InflationHedgeContent
        heading="Why Private Markets?"
        subHeading="Private markets have historically outperformed public markets throughout business cycles."
        description="<p>Private markets appeal to both institutional and
          non-institutional investors due to their<span> potential for higher
          returns, lower correlation with public equity markets, and 
          access to otherwise inaccessible markets and strategies. </span></p>
          
         <p> During the 2008 financial crisis, deals from top-quartile
          vintages raised around the globe generated a <span>61% internal
          rate of return,</span> compared to the S&P 500’s -38% annual return.</p>"
        imageUrl={PrivateMarketImage}
        reverse
      />
      <InflationHedgeContent
        heading="Why should I invest with MarketX?"
        subHeading="MarketX Ventures combines the best elements of venture capital, privileged geographic access, and innovative
          liquidity opportunities to capture high-impact companies and make them accessible to investors."
        description="<p>Our Inflation Hedge Structured Product is a <span> single investment providing one structured, risk-adjusted return,</span> combining private investment securities with a structured interest rate hedge.</p>

        <p> Holding the investment for two years, the worst-case scenario would be the company not IPO-ing or getting acquired, resulting in a<span> maximum loss of 45%.</span></p>
          
         <p> On the upside, pre-IPO companies can return as much as 200% when triggering an exit event,<span> potentially growing the initial investment by 105%.</span></p>"
        imageUrl={BullImage}
      />
      <PartialContainer>
        <div className="lg:px-32 lg:pb-24 lg:pt-12">
          <FAQSection />
        </div>
      </PartialContainer>
    </AppLayout>
  )
}

export default InflationHedge
